<ng-template #languageDropdownTemplate let-language>
  <span class="dropdown-item-language">{{ language }}</span>
</ng-template>
<app-tippy-dropdown icon="language" [items]="languages" [showTitle]="false" [(ngModel)]="selectedLanguage"
  (ngModelChange)="onLanguageChange($event)" [template]="languageDropdownTemplate"></app-tippy-dropdown>